module.exports = __webpack_public_path__ + "img/android2.png";